/* Option C only: carousel buttons and expandable collection descriptions. Without this script, carousels still swipe
   and descriptions show in full. */
(function () {
  const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- carousels: the buttons move one screenful of cards; at an end the button says it is unavailable ---------- */
  function initRail(sec) {
    const track = sec.querySelector('[data-optc-track]');
    const prev = sec.querySelector('[data-optc-prev]'), next = sec.querySelector('[data-optc-next]');
    if (!track || !prev || !next) return;
    const bar = sec.querySelector('[data-optc-bar]'), thumb = bar && bar.firstElementChild;
    const set = (btn, off) => { btn.setAttribute('aria-disabled', off ? 'true' : 'false'); btn.classList.toggle('is-off', off); };
    function update() {
      const max = track.scrollWidth - track.clientWidth;
      const none = max <= 2;
      prev.hidden = next.hidden = none;
      if (bar) {
        bar.hidden = none;
        thumb.style.width = (100 * track.clientWidth / track.scrollWidth) + '%';
        thumb.style.marginLeft = (100 * track.scrollLeft / track.scrollWidth) + '%';
      }
      set(prev, track.scrollLeft <= 2);
      set(next, track.scrollLeft >= max - 2);
    }
    function step(dir) {
      const first = track.firstElementChild;
      if (!first) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const card = first.getBoundingClientRect().width + gap;
      const per = Math.max(1, Math.floor((track.clientWidth + gap) / card));
      track.scrollBy({ left: dir * per * card, behavior: reduce ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', () => { if (prev.getAttribute('aria-disabled') !== 'true') step(-1); });
    next.addEventListener('click', () => { if (next.getAttribute('aria-disabled') !== 'true') step(1); });
    let raf = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    addEventListener('resize', update);
    addEventListener('load', update);
    update();
  }

  /* ---------- collection descriptions: about three lines, then Read more; the full text is always in the page ---------- */
  function initDesc(box) {
    const text = box.querySelector('.aad-cdesc__t'), btn = box.querySelector('.aad-cdesc__more');
    if (!text || !btn) return;
    let open = false;
    function fit() {
      if (open) return;
      box.classList.add('is-clamped');
      const over = text.scrollHeight > text.clientHeight + 2;
      btn.hidden = !over;
      if (!over) box.classList.remove('is-clamped');
    }
    btn.addEventListener('click', () => {
      open = !open;
      box.classList.toggle('is-clamped', !open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show less' : 'Read more';
      if (!open) fit();
    });
    addEventListener('resize', fit);
    fit();
  }

  function boot() {
    document.querySelectorAll('[data-optc-rail]').forEach(initRail);
    document.querySelectorAll('[data-optc-desc]').forEach(initDesc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
